/**
 * Map an array modifier names to the correct component modifier class names.
 *
 * For example ["full", "dark"] would be transformed into classes
 * `.component--full` and `.component--dark`
 */
interface BuildModifierClassNamesProperties {
    modifiers: [string];
    styles: Record<string, string>;
    rootClassName: string;
}
export function buildModifierClassNames({
    modifiers,
    styles,
    rootClassName = "component",
}: BuildModifierClassNamesProperties): string[] {
    return modifiers.map((item) => styles[`${rootClassName}--${item}`]);
}
